import VrrVideoPlayer from './VrrVideoPlayer';

export default VrrVideoPlayer;
